import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import {Modal,Button,Col,Row,Container} from 'react-bootstrap'
import PropTypes from 'prop-types';
import AccountCircleRoundedIcon from '@material-ui/icons/SearchRounded';
import {withStyles,styled } from '@material-ui/core/styles';
import SaveIcon from '@material-ui/icons/SearchRounded';
 import styles2 from './DatosPersona.css'
import { GetCTID } from '../../services/SecurityService';
import Stepper from '@keyvaluesystems/react-stepper';
import Dropdown from 'react-bootstrap/Dropdown';


 class DatosPersona2 extends Component {
  constructor(props) {
    super(props);

    this.togglePassword=this.togglePassword.bind(this);
this.onSubmit = this.onSubmit.bind(this);
this.onChangeNombre = this.onChangeNombre.bind(this);
this.onChangeCorreo = this.onChangeCorreo.bind(this);
this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);


        this.handleShow2 = this.handleShow2.bind(this);
        this.handleClose2 = this.handleClose2.bind(this);

    this.state = {
   
      Nombre:'',
      Correo:'',
     
      tramite:false,
      boton:false,
      id_estatus:'',
      tt:'',
      estatus:'',
 
   
  }

 

}
  handleClose() {
    this.setState({ show: false });
  }
  
  handleShow() {
    this.setState({ show: true });
  }


  handleClose2() {
    this.setState({ show2: false });
  }
  
  handleShow2() {
    this.setState({ show2: true });
  }

  togglePassword =()=>{
    if(this.state.passwordType==="password")
    {
     this.setState({passwordType:"text"})
     return;
    }
    this.setState({passwordType:"password"})
  }
  
  componentDidMount(){
    console.log("idoficio");
    console.log(this.props.id_oficio)

    console.log("PROPS DATOSasd--->");
    console.log(this.props);
  

}

            onChangeNombre(e) {
              this.setState({
             Nombre: e.target.value.toUpperCase()
              });
              }
       
                                                onChangeCorreo(e) {
                                                  this.setState({
                                                 Correo: e.target.value.toUpperCase()
                                                  });
                                                  }

                      

  onSubmit(e) {
  e.preventDefault();



  
  GetCTID({id:this.state.Nombre,curp:this.state.Correo}).then(response => {
    console.log(response)

    if(response!="No existen clientes en la BBDD."){
   

this.setState({
  tramite:true,
  id_estatus:response[0].id_estatus,
  estatus:response[0].estatus,
})

}else{
  //alert("Trámite no encontrado!");
  this.setState({
    tramite:false,
    id_estatus:'',
    estatus:'',
  })

}

}).catch(err =>  this.setState({ 
    oficios: [],
    oficiosR:[],



  
  })  ); 
  }





onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
};




  render() {
 

 
    const styles = {
      LineSeparator: () => ({
        backgroundColor: "#88213A",
      }),
      ActiveNode: () => ({
        backgroundColor: "#88213A",
      }),
      CompletedNode: () => ({
        backgroundColor: "#88213A",
      }),
    };
  

    return (


      
        <div style={{ }}>

          
            
            <form onSubmit={this.onSubmit}>
            <div className="form-group">
              
            <br></br>

            <h1 class="display-6" style= {{ color:'black'}} align="center" >  &nbsp;Consulta el Estatus de Tu Trámite  </h1> 
            

<br></br>
<center>
<img src={require('./progreso.png')} style={{width:'40%'}}/>
</center>       


                <Grid container spacing={1} style={{padding:'0.7em 2.9em'}}  >

                <Grid  item xs={12}>
<center>
<div style={{color:'#88213a',display:this.state.boton ? 'block' : 'none'}} class="spinner-border" role="status">
  <span class="visually-hidden">Loading...</span>
</div>
</center>
                  </Grid>
                  
                <Grid  item xs={5}>
                <h5>Matrícula</h5>
                    <input style={{borderColor:'#EEEEEE',borderWidth:2,borderRadius:10}}
                      type="text" 
                      className="form-control" 
                      value={this.state.Nombre}
                      onChange={this.onChangeNombre}
                  
                     
                      />
                      </Grid>

                      <Grid  item xs={2}>
                        <center>
                      <h5 style={{color:'#FFFFFF'}}>ó</h5>
                      </center>
                      <center>
                      <h5>ó</h5>
                      </center>
                      </Grid>

                      <Grid item xs={5}>
                      <h5>CURP</h5>

                    <input style={{borderColor:'#EEEEEE',borderWidth:2,borderRadius:10}} type="text"
                      className="form-control"
                      value={this.state.Correo}
                      onChange={this.onChangeCorreo}
                    
                      />
                      </Grid>
                   

                
                 </Grid>
                 
                 
                 <Grid container spacing={1} >
                 
                

                      


                   
                      
                      <br/>
                      <br/>
                      <br/>
                      {this.state.tt!='' ? <Grid item xs={12}>
<center>Trámite no encontrado!</center>
    </Grid> :null }
                      <Grid item xs={12}>
                     {this.state.tramite ? <Stepper

styles={styles}      
  steps={[
    {
      stepLabel: "Registrado",
      completed: this.state.id_estatus>=2 ? true : false,
    },
    {
      stepLabel: "Pendiente",
      completed: this.state.id_estatus>=3 ? true : false,
    },
    {
      stepLabel: "Trámite",
      completed: this.state.id_estatus>=4 ? true : false,
    },
    {
      stepLabel: "En firmas",
      completed: this.state.id_estatus>=5 ? true : false,
    },
    {
      stepLabel: "Por entregar",
      completed: this.state.id_estatus>=6 ? true : false,
    },
    {
      stepLabel: "Entregado",
      completed: this.state.id_estatus==6 ? true : false,
    },
  ]}
  currentStepIndex={this.state.id_estatus-1}
  orientation={'horizontal'}
/>: null} 


</Grid>
<Grid item xs={12}>
<center>{this.state.id_estatus==1 ? "Su trámite ha sido registrado" : this.state.id_estatus==2 ? "Su trámite esta siendo procesado" : this.state.id_estatus==3 ? "Su trámite esta siendo procesado" : this.state.id_estatus==4 ? "Su trámite se encuentra siendo firmado" : this.state.id_estatus==5 ? "Su trámite esta listo para ser entregado" : this.state.id_estatus==6 ? "Su trámite fue entregado" : ''}</center>
    </Grid>                  <br/>
                       

<Grid container spacing={1} >

  
                    


                      
<Grid item xs={12} style={{alignItems:'center',justifyContent:'center',display:'flex'}}>
<Button style={{width:'20%',borderRadius:'15rem', backgroundColor:'#D68095',color:'#FFFFFF',fontWeight:'bold'}}   onClick={()=>{ this.props.handleClose();
this.setState({boton:false});

}} variant="outlined" > CANCELAR </Button> 

&nbsp; <Button disabled={this.state.boton}  style={{width:'30%',borderRadius:'15rem', backgroundColor:this.state.boton ? '#7f7f82' : '#88213a',color:'#FFFFFF',fontWeight:'bold'}}   onClick={()=>{ 

  this.setState({boton:true});
GetCTID({id:this.state.Nombre,curp:this.state.Correo}).then(response => {
  console.log(response)

  if(response!="No existen clientes en la BBDD."){
 

this.setState({
tramite:true,
tt:'',
id_estatus:response[0].id_estatus,
estatus:response[0].estatus,
})
this.setState({boton:false});

}else{
//alert("Tramite no encontrado!");
this.setState({
  tramite:false,
  tt:'tne',
  id_estatus:'',
  estatus:'',
})
this.setState({boton:false});

}

}).catch(err =>  this.setState({ 
  oficios: [],
  oficiosR:[],
boton:false,
tramite:false,
tt:'',
id_estatus:'',
estatus:'',



})  ); 


}} variant="outlined" > Consultar <SaveIcon/></Button> 
                                            </Grid>
                                            <br></br>
                                            <br></br>
                                            <br></br>
                                            <br></br>
                                            <br></br>
                                            </Grid>  
                                            
                    </Grid>
                    

                </div>
              





            
                <div className="form-group">
                  { <input  ref="inputR"
                  disabled={this.state.botondisabled}
                    style={{color:'#4885ed',borderColor:'#4885ed',display:'none'}} variant="outlined" type="submit" value="ACTUALIZAR"  className="btn btn-outline"/>  }
                   
    
              
              
                </div>
                

            </form>
        </div>
    )
  }
}


const styles = {
  card: {
    maxWidth: 500,
    borderRadius:15,
  },
  media: {
    objectFit: 'cover',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  searchBar: {
    color: 'white',
    marginLeft: 6
  },
  list:{
  borderColor:'#A11B39',
  borderWidth:2
  }

};

DatosPersona2.propTypes = {
  classes: PropTypes.object.isRequired,
  onSubmit: PropTypes.func
};

export default withStyles(styles)(DatosPersona2);